import React from "react";
import './Event.css';

import { Link } from "react-router-dom";

import { FaClock } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";



const Event = ({ event }) => {

    return (

        <div className="event-item">

            <img src={event.image} alt={event.title} /> {/* Event Image */}

            <div className="content">

                {/* Event details section */}
                <div className='details'>

                    {/* Event Date */}
                    <h3>
                        <div className='icon'><FaClock /></div>
                        <span>{event.details.date}</span>
                    </h3>

                    {/* Event Location */}
                    <h3>
                        <div className='icon'><FaLocationDot /></div>
                        <span>{event.details.location}</span>
                    </h3>

                </div>

                {/* Link to the individual Event page */}
                <Link
                    to={{
                        pathname: '/Events/' + event.title,  // Navigate to the specific Event page
                    }}
                    location = {{event}}  // Passing Event details to the linked page
                    className="main-heading"
                    state= {event}> 
                    {event.title} {/* Event Title */}
                </Link>

            </div>

        </div>
    );
};

export default Event;